<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4>Mapping Group and Item </h4>
          </div>

          <div class="card-body">
            <form [formGroup]="MappingGForm">
              <div class="cardSearch2">
                <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseExample" (click)="showhideAdd()" role="button"
                aria-expanded="false" aria-controls="collapseExample">
                <header class="panel-heading">
                    <h5 class="panel-title">Add Mapping Group and Item(Tap to Expand)</h5>
                </header>
            </div>
            <div *ngIf="IsAddpanelshow" id="collapseExample">
              <div class="card-body2">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Group Name</label></div>
                    <div class="col-md-7">
                      <p-dropdown [options]="groupList" optionLabel="GroupName" placeholder="--Select--" formControlName="SelectedGroup"
                      filter="true" [showClear]="true">
                    </p-dropdown>
                    <mat-error
                    *ngIf="GetFormControls('SelectedGroup').invalid && (GetFormControls('SelectedGroup').dirty || GetFormControls('SelectedGroup').touched)"
                    class="ValidationError">
                    <mat-error *ngIf="GetFormControls('SelectedGroup').errors.required">
                      Group Name is required.
                    </mat-error>
                  </mat-error>    
                  </div>
                  <div class="col-md-1"></div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Item Name</label></div>
           
                      <div class="col-md-8">  
                        <p-dropdown [options]="itemList" optionLabel="ItemName" placeholder="--Select--" formControlName="SelectedItem"
                        filter="true" [showClear]="true">
                      </p-dropdown>  
                      <mat-error
                      *ngIf="GetFormControls('SelectedItem').invalid && (GetFormControls('SelectedItem').dirty || GetFormControls('SelectedItem').touched)"
                      class="ValidationError">
                      <mat-error *ngIf="GetFormControls('SelectedItem').errors.required">
                        Item Name is required.
                      </mat-error>
                    </mat-error>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <br>
              </div>
              <div class="row">
                 
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                  <button type="submit"  style="margin-top: 10px;margin-left: 20px;margin-right: 80px;" class="btn-primary1" (click)="Adddata()" >Add</button>
                  <button class="btn-primary1" (click)="Export()">Export as Excel</button>
                </div>
                  <div class="col-md-4"></div>
                </div>
                </div>
              </div>
              </div>
            </div>
              </div>
              <div class="clearfix"></div>

              <div class="cardSearch2">
                <div class="card-header2 form-control2" data-toggle="collapse" href="#collapseSearch" (click)="showhide()" role="button"
                    aria-expanded="false" aria-controls="collapseSearch">
                    <header class="panel-heading">
                        <h5 class="panel-title">Search(Tap to Expand)</h5>
                    </header>
                </div>
                <div *ngIf="Ispanelshow" id="collapseSearch">
                    <div class="card-body2">
                        <div class="row">
                          <div class="form-group2 col-md-6">
                            <label class="required">Assignment Group Name</label>
                            <p-dropdown [options]="groupList" optionLabel="GroupName" placeholder="--Select--" formControlName="GroupSearch"
                            filter="true" [showClear]="true">
                          </p-dropdown>
                        </div>
                        <div class="form-group2 col-md-6">
                          <label class="required">Status</label>
                          <p-dropdown [options]="statusList" optionLabel="StatusName" placeholder="--Select--" formControlName="StatusSearch"
                          filter="true" [showClear]="true">
                        </p-dropdown>
                      </div>
                        </div>
                      
                        <div class="clearfix"></div>
                      <div class="row">
      
                        <div class="col-md-12" style="text-align: center;">
                          <button class="btn-primary1" (click)="Exit()">Exit</button>
                          <button class="btn-primary1" (click)="ResetData()">Reset</button>
                          <button type="submit" style="margin-top: 10px;margin-right: 80px;" value="Submit" class="btn-primary1" (click)="GetResult()" >Get Result</button>
                          
      
                        </div>
                        
                      </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>

                <div class="row">
                 
                <div class="col-md-12">
                 
                  <div class="mat-elevation-z8 top-margin-border" #TABLE>
                    <table mat-table [dataSource]="MappingDataSource" style="width:100% !important">
           
                      <ng-container matColumnDef="Id">
                        <th mat-header-cell *matHeaderCellDef> Id </th>
                        <td mat-cell *matCellDef="let element"> {{element.Id}} </td>
                      </ng-container>
            
                      <ng-container matColumnDef="GroupName">
                        <th mat-header-cell *matHeaderCellDef> Group Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.GroupName}} </td>
                      </ng-container>
      
                      <ng-container matColumnDef="ItemId" >
                        <th mat-header-cell *matHeaderCellDef> ItemId </th>
                        <td mat-cell *matCellDef="let element" > {{element.ItemId}} </td>
                      </ng-container>

                      <ng-container matColumnDef="SubCategory">
                        <th mat-header-cell *matHeaderCellDef> SubCategory Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.SubCategoryName}} </td>
                      </ng-container>
      
                      <ng-container matColumnDef="ItemName">
                        <th mat-header-cell *matHeaderCellDef> Item Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.ItemName}} </td>
                      </ng-container>

                    
                      <ng-container matColumnDef="GroupId">
                        <th mat-header-cell *matHeaderCellDef> Group Id </th>
                        <td mat-cell *matCellDef="let element"> {{element.GroupId}} </td>
                      </ng-container>

                      <ng-container matColumnDef="Status">
                        <th mat-header-cell *matHeaderCellDef> Status </th>
                        <td mat-cell *matCellDef="let element"> {{element.Status}} </td>
                      </ng-container>
            

                      <ng-container matColumnDef="Edit">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element;  let j = index;" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="rowclickdata(element.Id)"> Edit </td>
                      </ng-container>

                      <ng-container matColumnDef="Delete">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element;  let j = index;" style="cursor:pointer;color:blue; text-decoration: underline;" (click)="rowdeletedata(element.Id)"> Update Status </td>
                      </ng-container>
            
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
          
                    <mat-paginator  #paginator
                    [length]="_global.length"
                    [pageIndex]="_global.pageIndex"
                    [pageSize]="_global.RecordSize"
                    [pageSizeOptions]="[5, 10, 25, 100]"
                    (page)="onPaginateChange1($event)"></mat-paginator>
        </div>
              </div>
             
              
                </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

